import React from 'react';
import Typewriter from 'typewriter-effect';
import { TypewriterWrapper } from './components';

export const Type = (): React.ReactNode => {
  return (
    <TypewriterWrapper
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'flex-start' },
      }}
    >
      <Typewriter
        options={{
          strings: [
            'Software Engineer',
            'Full Stack Web Developer',
            'Microservices Engineer',
            'Open Source Contributor',
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 50,
          wrapperClassName: 'typewriter-wrapper',
          cursorClassName: 'typewriter-cursor',
        }}
      />
    </TypewriterWrapper>
  );
};
